import { render } from "./addsupplier.vue?vue&type=template&id=16bc63ed"
import script from "./addsupplier.vue?vue&type=script&lang=js"
export * from "./addsupplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__